module.exports = __webpack_public_path__ + "img/signup.bb51d5f.svg";